import { FormattedMessage } from "react-intl";

export function ApplicationDataNotice({ company = false }: { company?: boolean }) {
  return <div className="space-y-2 text-smycles-meta text-ink-muted">
    <p><FormattedMessage id="share.applications.dataNotice.records" /></p>
    {!company ? <p><FormattedMessage id="share.applications.dataNotice.profile" /></p> : null}
    <p><FormattedMessage id="share.applications.dataNotice.contact" /></p>
  </div>;
}
